import { useState } from "react";
import { Input } from "components/ui/input";

export type DateRange = { date_from?: string; date_to?: string };

type Preset = "7d" | "30d" | "mes" | "ano" | "custom";

const toYMD = (date: Date) => date.toISOString().slice(0, 10);

function rangeForPreset(preset: Preset): DateRange {
  const today = new Date();
  const date_to = toYMD(today);

  if (preset === "7d") {
    const d = new Date(today);
    d.setDate(d.getDate() - 6);
    return { date_from: toYMD(d), date_to };
  }
  if (preset === "30d") {
    const d = new Date(today);
    d.setDate(d.getDate() - 29);
    return { date_from: toYMD(d), date_to };
  }
  if (preset === "mes") {
    const d = new Date(today.getFullYear(), today.getMonth(), 1);
    return { date_from: toYMD(d), date_to };
  }
  if (preset === "ano") {
    const d = new Date(today.getFullYear(), 0, 1);
    return { date_from: toYMD(d), date_to };
  }
  return {};
}

// Usado pelo componente pai como estado inicial, para não disparar um fetch
// extra em {} (sem filtro) antes do useEffect de montagem substituir por 30d.
export const getDefaultDateRange = (): DateRange => rangeForPreset("30d");

const PRESETS: { key: Preset; label: string }[] = [
  { key: "7d", label: "7 dias" },
  { key: "30d", label: "30 dias" },
  { key: "mes", label: "Este mês" },
  { key: "ano", label: "Este ano" },
  { key: "custom", label: "Personalizado" },
];

type Props = {
  onChange: (range: DateRange) => void;
};

const DateRangeFilter = ({ onChange }: Props) => {
  const [active, setActive] = useState<Preset>("30d");
  const [customFrom, setCustomFrom] = useState("");
  const [customTo, setCustomTo] = useState("");

  const selectPreset = (preset: Preset) => {
    setActive(preset);
    if (preset === "custom") return;
    onChange(rangeForPreset(preset));
  };

  const applyCustom = () => {
    if (!customFrom && !customTo) return;
    onChange({ date_from: customFrom || undefined, date_to: customTo || undefined });
  };

  return (
    <div className="flex flex-wrap items-center gap-2">
      <div className="flex items-center rounded-lg border border-slate-200 bg-white p-0.5">
        {PRESETS.map((p) => (
          <button
            key={p.key}
            onClick={() => selectPreset(p.key)}
            className={`px-3 py-1.5 text-xs font-medium rounded-md transition-colors ${
              active === p.key ? "bg-brand-sidebar text-white" : "text-slate-600 hover:bg-slate-100"
            }`}
          >
            {p.label}
          </button>
        ))}
      </div>

      {active === "custom" && (
        <div className="flex items-center gap-2">
          <Input type="date" value={customFrom} onChange={(e) => setCustomFrom(e.target.value)} className="h-8 w-[150px] text-xs" />
          <span className="text-slate-400 text-xs">até</span>
          <Input type="date" value={customTo} onChange={(e) => setCustomTo(e.target.value)} className="h-8 w-[150px] text-xs" />
          <button
            onClick={applyCustom}
            className="px-3 py-1.5 text-xs font-medium rounded-md bg-brand-sidebar text-white hover:bg-brand-sidebar/90"
          >
            Aplicar
          </button>
        </div>
      )}
    </div>
  );
};

export default DateRangeFilter;
